var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLRepairMIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.5C17.2031 12.5 20 9.70312 20 6.25C20 5.65234 19.9141 5.07422 19.7578 4.52344C19.6367 4.10156 19.1172 4.00781 18.8086 4.31641L15.8086 7.31641C15.6914 7.43359 15.5312 7.5 15.3672 7.5H13.125C12.7812 7.5 12.5 7.21875 12.5 6.875V4.63281C12.5 4.46875 12.5664 4.30859 12.6836 4.19141L15.6836 1.19141C15.9922 0.882812 15.8945 0.363281 15.4766 0.242188C14.9258 0.0859375 14.3477 0 13.75 0C10.2969 0 7.5 2.79688 7.5 6.25C7.5 6.99609 7.63281 7.71484 7.87109 8.37891L0.777344 15.4727C0.28125 15.9688 0 16.6445 0 17.3477C0 18.8125 1.1875 20 2.65234 20C3.35547 20 4.03125 19.7188 4.52734 19.2227L11.6211 12.1289C12.2852 12.3711 13.0039 12.5 13.75 12.5ZM3.125 15.9375C3.37364 15.9375 3.6121 16.0363 3.78791 16.2121C3.96373 16.3879 4.0625 16.6264 4.0625 16.875C4.0625 17.1236 3.96373 17.3621 3.78791 17.5379C3.6121 17.7137 3.37364 17.8125 3.125 17.8125C2.87636 17.8125 2.6379 17.7137 2.46209 17.5379C2.28627 17.3621 2.1875 17.1236 2.1875 16.875C2.1875 16.6264 2.28627 16.3879 2.46209 16.2121C2.6379 16.0363 2.87636 15.9375 3.125 15.9375Z",
    fill: "#059669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1870"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLRepairMIcon);
export default __webpack_public_path__ + "static/media/l_repair_m_icon.9407f439dca2cc8cb8126d03e4234178.svg";
export { ForwardRef as ReactComponent };